import Swiper from "swiper";
import { Autoplay } from "swiper/modules";
import "swiper/css";

export const initAuraTopBarSwiper = (): void => {
  // Guard Clause: Only run if the NOC top bar is present
  const topBar = document.querySelector<HTMLElement>(".top-bar-aura");
  if (!topBar) return;

  const swiperElement = topBar.querySelector<HTMLElement>(".top-bar-swiper");
  if (!swiperElement) return;

  new Swiper(swiperElement, {
    modules: [Autoplay],
    direction: "vertical",
    loop: true,
    autoplay: {
      delay: 4000, // Slightly slower reading time
      disableOnInteraction: false,
    },
    allowTouchMove: false,
  });
};
